import { render, staticRenderFns } from "./LayoutGroup.vue?vue&type=template&id=8d935d88&"
import script from "./LayoutGroup.vue?vue&type=script&lang=ts&"
export * from "./LayoutGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports